export default __webpack_public_path__ + "static/media/css-3.e7a9de36.svg";